/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getRadiologyStudies } from 'app/entities/radiology-study/radiology-study.reducer';
import { getEntities as getTrimesters } from 'app/entities/trimester/trimester.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pregnancy-prescription.reducer';

export const PregnancyPrescriptionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const prescriptions = useAppSelector(state => state.prescription.entities);
  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const radiologyStudies = useAppSelector(state => state.radiologyStudy.entities);
  const trimesters = useAppSelector(state => state.trimester.entities);
  const pregnancyPrescriptionEntity = useAppSelector(state => state.pregnancyPrescription.entity);
  const loading = useAppSelector(state => state.pregnancyPrescription.loading);
  const updating = useAppSelector(state => state.pregnancyPrescription.updating);
  const updateSuccess = useAppSelector(state => state.pregnancyPrescription.updateSuccess);

  const handleClose = () => {
    navigate(`/pregnancy-prescription${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPrescriptions({}));
    dispatch(getLabPrescriptions({}));
    dispatch(getRadiologyStudies({}));
    dispatch(getTrimesters({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pregnancyPrescriptionEntity,
      ...values,
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      labPrescription: labPrescriptions.find(it => it.id.toString() === values.labPrescription?.toString()),
      radiologyStudy: radiologyStudies.find(it => it.id.toString() === values.radiologyStudy?.toString()),
      trimester: trimesters.find(it => it.id.toString() === values.trimester?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pregnancyPrescriptionEntity,
          prescription: pregnancyPrescriptionEntity?.prescription?.id,
          labPrescription: pregnancyPrescriptionEntity?.labPrescription?.id,
          radiologyStudy: pregnancyPrescriptionEntity?.radiologyStudy?.id,
          trimester: pregnancyPrescriptionEntity?.trimester?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pregnancyPrescription.home.createOrEditLabel" data-cy="PregnancyPrescriptionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.home.createOrEditLabel">
              Create or edit a PregnancyPrescription
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pregnancy-prescription-id"
                  label={translate('tinyMedicRestApp.pregnancyPrescription.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.active')}
                id="pregnancy-prescription-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.draft')}
                id="pregnancy-prescription-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.cursor')}
                id="pregnancy-prescription-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.lastUpdated')}
                id="pregnancy-prescription-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.microSec')}
                id="pregnancy-prescription-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyPrescription.timestampEntry')}
                id="pregnancy-prescription-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="pregnancy-prescription-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.pregnancyPrescription.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-prescription-labPrescription"
                name="labPrescription"
                data-cy="labPrescription"
                label={translate('tinyMedicRestApp.pregnancyPrescription.labPrescription')}
                type="select"
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-prescription-radiologyStudy"
                name="radiologyStudy"
                data-cy="radiologyStudy"
                label={translate('tinyMedicRestApp.pregnancyPrescription.radiologyStudy')}
                type="select"
              >
                <option value="" key="0" />
                {radiologyStudies
                  ? radiologyStudies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-prescription-trimester"
                name="trimester"
                data-cy="trimester"
                label={translate('tinyMedicRestApp.pregnancyPrescription.trimester')}
                type="select"
              >
                <option value="" key="0" />
                {trimesters
                  ? trimesters.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pregnancy-prescription" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PregnancyPrescriptionUpdate;
